module.exports = __webpack_public_path__ + "a045ccec726e3c3e8d4fbd86e2ad8b94.png";